import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';
import {
  IApiCityResponse,
  ICityState,
} from 'src/app/api/interfaces/city.interface';
import { setInitialCityData, updateCityData } from './cityState.actions';

export interface ICityActions {
  type:
    | '[Auth API] set initial cityData Success'
    | '[Auth API] update cityData Success'
    | string;
}

export const initialState: ICityState = {
  balances: [],
  id: 0,
  system: true,
  cityTaxRate: {
    id: 0,
    cityId: 1,
    craft: 0,
    transferIn: 0,
    transferOut: 0,
  },
  displayName: '',
  mysteryBoxes: [],
};

const _cityStateReducer = createReducer(
  initialState,
  on(setInitialCityData, (state, { responseData }) => {
    return {
      ...state,
      balances: responseData.balances,
      id: responseData.id,
      system: responseData.system,
      displayName: responseData.displayName,
      cityTaxRate: responseData.cityTaxRate,
    };
  }),
  on(updateCityData, (state, { responseData }) => {
    return { ...state, ...responseData };
  })
);

export function cityStateReducer(
  state: ICityState | undefined,
  action: ICityActions
) {
  return _cityStateReducer(state, action);
}

export const selectCityState = createSelector(
  createFeatureSelector<IApiCityResponse>('cityState'),
  (state) => state
);
